// extracted by mini-css-extract-plugin
module.exports = {"container":"packages-primitives-Icon-style__container--U6p7U"};